/* eslint-disable comma-dangle, no-var, one-var, react/forbid-prop-types, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Sortable = require("../components/sortable.jsx");

var ApiOptions = require("../perseus-api.jsx").Options;
var shuffle = require("../util.js").shuffle;

var _require = require("../gorgon/proptypes.js"),
    linterContextProps = _require.linterContextProps,
    linterContextDefault = _require.linterContextDefault;

var HORIZONTAL = "horizontal",
    VERTICAL = "vertical";

var Sorter = React.createClass({
    displayName: "Sorter",

    propTypes: {
        apiOptions: ApiOptions.propTypes,
        correct: React.PropTypes.array,
        layout: React.PropTypes.oneOf([HORIZONTAL, VERTICAL]),
        onChange: React.PropTypes.func,
        padding: React.PropTypes.bool,
        problemNum: React.PropTypes.number,
        trackInteraction: React.PropTypes.func.isRequired,
        linterContext: linterContextProps
    },

    getDefaultProps: function getDefaultProps() {
        return {
            correct: [],
            layout: HORIZONTAL,
            padding: true,
            problemNum: 0,
            onChange: function onChange() {},
            linterContext: linterContextDefault
        };
    },

    render: function render() {
        var options = shuffle(this.props.correct, this.props.problemNum,
        /* ensurePermuted */true);

        var marginPx = this.props.apiOptions.isMobile ? 8 : 5;

        return React.createElement(
            "div",
            { className: "perseus-widget-sorter perseus-clearfix" },
            React.createElement(Sortable, {
                options: options,
                layout: this.props.layout,
                margin: marginPx,
                padding: this.props.padding,
                onChange: this.handleChange,
                linterContext: this.props.linterContext,
                ref: "sortable"
            })
        );
    },

    handleChange: function handleChange(e) {
        this.props.onChange(e);
        this.props.trackInteraction();
    },

    getUserInput: function getUserInput() {
        return { options: this.refs.sortable.getOptions() };
    },

    simpleValidate: function simpleValidate(rubric) {
        return Sorter.validate(this.getUserInput(), rubric);
    }
});

_.extend(Sorter, {
    validate: function validate(state, rubric) {
        var correct = _.isEqual(state.options, rubric.correct);

        return {
            type: "points",
            earned: correct ? 1 : 0,
            total: 1,
            message: null
        };
    }
});

module.exports = {
    name: "sorter",
    displayName: "Sorter",
    widget: Sorter,
    isLintable: true
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/sorter.jsx
 ** module id = 148
 ** module chunks = 0 1
 **/